var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55915 4.99998H10.9297M3.05618 1V2.20014M11.3359 1V2.19999M13.7734 4.68518L13.7734 12.5148C13.7734 13.8873 12.6608 15 11.2883 15H3.25862C1.88609 15 0.773438 13.8873 0.773438 12.5148V4.68518C0.773438 3.31265 1.88609 2.19999 3.25862 2.19999H11.2883C12.6608 2.19999 13.7734 3.31265 13.7734 4.68518Z",
    stroke: "black",
    strokeWidth: 0.828396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDate);
export default __webpack_public_path__ + "static/media/LightDate.98834f4d60c874b7826fdf4640865a4b.svg";
export { ForwardRef as ReactComponent };